
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { CreditCard, ArrowRight, Shield } from "lucide-react";

export const CTASection = () => {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-indigo-900 rounded-3xl p-10 md:p-16 shadow-xl overflow-hidden relative">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <pattern id="dots" width="10" height="10" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>
      </div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full mb-6">
          <Shield className="h-4 w-4 text-white" />
          <span className="text-white text-sm font-medium">Secure & Trusted Platform</span>
        </div>
        
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">
          Ready to Get Started?
        </h2>
        <p className="text-lg md:text-xl text-indigo-100 mb-10 max-w-2xl mx-auto">
          Join thousands of satisfied borrowers who have found their perfect lending match on Obotan's secure lending platform.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="gap-2 bg-white text-indigo-700 hover:bg-indigo-50 shadow-lg px-8 transition-all duration-300 w-full sm:w-auto">
            <Link to="/register">
              <CreditCard className="h-5 w-5" />
              Apply Now
              <ArrowRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="gap-2 border-2 border-white/50 text-white hover:bg-white/10 transition-all duration-300 w-full sm:w-auto">
            <Link to="/lenders">
              Learn More
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
